
import { Component, Vue } from "vue-property-decorator";
import { Bar } from 'vue-chartjs';
import { dataVisualizationModule } from "@/store";
import {
  Chart as ChartJS,
  Title,
  Tooltip,
  Legend,
  CategoryScale,
  LinearScale,
  BarElement,
} from 'chart.js';

ChartJS.register(Title, Tooltip, Legend, BarElement, CategoryScale, LinearScale);

@Component({
  components: {
    Bar
  }
})
export default class Comorbidities extends Vue {
  chartDatas = {
    labels: [] as string[],
    datasets: [] as any[]
  };

  chartOptions = {
    responsive: true,
    maintainAspectRatio: false,
    scales: {
      x: { stacked: true },
      y: { stacked: true }
    }
  };

  get rawChartData(): any[] {
    return dataVisualizationModule.getChartData("comorbidities");
  }

  get chartDataAvailable(): boolean {
    return this.chartDatas.labels.length > 0 && this.chartDatas.datasets.length > 0;
  }

  async mounted() {
    try {
      await dataVisualizationModule.loadAll("comorbidities");

      const rawData = this.rawChartData;
      const groupedData: { [key: string]: number[] } = {};
      const labels: string[] = [];

      rawData.forEach(entry => {
        const group = entry.Value;
        const label = entry.Identifier;
        const count = entry.PatientCount;

        if (!labels.includes(label)) {
          labels.push(label);
        }

        if (!groupedData[group]) {
          groupedData[group] = [];
        }

        groupedData[group].push(count);
      });

      const barColors = [
        '#ffac1c', '#ff6f00', '#ffd700',
        '#ff8c00', '#ffa07a', '#ffc107'
      ];

      const datasets = Object.keys(groupedData).map((group, index) => ({
        label: group,
        data: groupedData[group],
        backgroundColor: barColors[index % barColors.length],
        stack: 'stack1'
      }));

      this.chartDatas = {
        labels,
        datasets
      };
    } catch (e) {
      console.error("Failed to load chart data", e);
    }
  }
}
